import { Button, Form, Modal, message } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteCategory } from "../../../../api/categories";

const DeleteCategory = ({ isVisible, setVisible, selected }: any) => {
  const { id } = selected;
  const queryClient = useQueryClient();

  const [form] = Form.useForm();

  const { mutate, isLoading } = useMutation({
    mutationFn: deleteCategory,
    onError: (error) => {
      message.error(`${error}`);
    },
    onSuccess: () => {
      message.success("Deleted Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["categories"] });
      setVisible(false);
    },
  });

  const onSubmit = async () => {
    mutate({ id });
  };

  return (
    <>
      <Modal
        title="Delete Category"
        open={isVisible}
        onCancel={() => setVisible(false)}
        footer={[
          <Button key="back" onClick={() => setVisible(false)}>
            Cancel
          </Button>,
          <Button
            key="submit"
            form="deleteCategory"
            htmlType="submit"
            onSubmit={onSubmit}
            loading={isLoading}
            className="border-0 bg-blue-600 text-white"
          >
            Delete
          </Button>,
        ]}
      >
        <Form
          id="deleteCategory"
          form={form}
          name="control-ref"
          onFinish={onSubmit}
          layout="vertical"
        >
          <div className="flex flex-col justify-center items-center">
            <div className="">
              Are you sure you want to
              <span className="text-red-600 px-1 font-bold">Delete</span>
              Category
            </div>
            <div className="font-bold">{selected?.name} ?</div>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default DeleteCategory;
